// *******************************************************************************
// Checkbox Group
// *******************************************************************************

attachEvent('.checkbox-group .checkbox input', 'change', (el) => {
  const parentItem = el.target.closest('.checkbox-group__item');
  const hiddenForm = parentItem.querySelector('.checkbox-group__hidden-inputs');
  hiddenForm?.classList.toggle('hide');
});
